enum PaymentOrderState {
    PendingApproval = "PENDING_APPROVAL",
    Cancelled = "USER_CANCELLED",
    Rejected = "USER_REJECTED",
    Submitted = "SUBMITTED",
    Expired = "EXPIRED"
}
export default PaymentOrderState